export default "__VITE_ASSET__CvJdVk3u__"